function About () {
  return (
    <>
      <h1>About</h1>
      <p>
        My Name is Kayla and I have been keeping Cardina Shrimp for several
        years now. I also just graduated from a Full Stack Web Development
        Bootcamp so I decided to make a website to showcase and sell my shrimp.
      </p>
    </>
  )
}

export default About
